import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', // or whatever path you're using
    '.json');
}
var MenuModule = /** @class */ (function () {
    function MenuModule() {
    }
    return MenuModule;
}());
export { MenuModule };
